import type { ChannelModel } from "../types/radio-types";
import {
  TELEMETRY_MAX_FREQUENCY_EXCLUSIVE,
  TELEMETRY_MIN_FREQUENCY
} from "./channel-normalization";

function decodeChannelName(rawName: Uint8Array): string {
  const out: number[] = [];
  for (let i = 0; i < 10 && i < rawName.length; i += 1) {
    const value = rawName[i];
    if (value < 32 || value > 127) {
      break;
    }
    out.push(value);
  }
  return new TextDecoder().decode(new Uint8Array(out)).replace(/\s+$/, "");
}

function isChannelActive(attribute: number, rxFrequency: number): boolean {
  const band = attribute & 0x07;
  if (band > 6) {
    return false;
  }
  if (rxFrequency < TELEMETRY_MIN_FREQUENCY || rxFrequency >= TELEMETRY_MAX_FREQUENCY_EXCLUSIVE) {
    return false;
  }
  return true;
}

export function decodeChannelFromEeprom(
  index: number,
  rawRecord: Uint8Array,
  rawName: Uint8Array,
  attributeWord: number
): ChannelModel {
  if (rawRecord.length !== 16) {
    throw new Error(`channel ${index}: record size must be 16 bytes`);
  }

  const view = new DataView(rawRecord.buffer, rawRecord.byteOffset, rawRecord.byteLength);
  const rxFrequency = view.getUint32(0, true);
  return {
    index,
    active: isChannelActive(attributeWord, rxFrequency),
    name: decodeChannelName(rawName),
    rxFrequency,
    band: attributeWord & 0x07,
    scanlistMask: 0,
    stepSetting: rawRecord[14],
    bandwidth: ((rawRecord[12] >> 1) & 0x01) === 1 ? "narrow" : "wide"
  };
}
